<!-- Wrapper Card -->
<app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">

  <!-- Sticky Header: Sample Info Summary -->
  <div class="sticky-top bg-white pt-3 pb-2" style="z-index: 10; border-bottom: 1px solid #dee2e6;">
    <div class="row align-items-center gx-2">
      <div class="col-md-6">
        <h5 class="mb-1 text-dark fw-bold">Edit Sample Detail</h5>
        <div class="text-muted small">{{ singleSampleData?.name }}</div>
      </div>
      <div class="col-md-6">
        <div class="d-flex flex-wrap justify-content-md-end gap-3 small text-muted">
          <!-- Stats: Initially, Assigned, Remaining -->
          <div class="d-flex align-items-center gap-1">
            <i class="bi bi-box-seam text-primary"></i>
            <span><strong>Initially:</strong> {{ singleSampleData?.totalItems }}</span>
          </div>
          <div class="d-flex align-items-center gap-1">
            <i class="bi bi-person-check text-success"></i>
            <span><strong>Assigned:</strong> {{ singleSampleData?.assignedItems }}</span>
          </div>
          <div class="d-flex align-items-center gap-1">
            <i class="bi bi-archive text-warning"></i>
            <span><strong>Remaining:</strong> {{ singleSampleData?.leftItems }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Form Wrapper (Scrollable) -->
  <div style="max-height: calc(100vh - 160px); overflow-y: auto; padding: 1rem;">
    <form [formGroup]="sampleForm" (ngSubmit)="submit()">
      <div class="row g-3">

        <!-- Category Select -->
        <div class="col-md-12">
          <label class="form-label fw-semibold m-0">Choose Category</label>
          <ng-select
            [items]="categories"
            bindLabel="name"
            bindValue="_id"
            formControlName="categoryId"
            placeholder="Select Category">
          </ng-select>
          @if (sampleForm.get('categoryId')?.invalid && sampleForm.get('categoryId')?.touched) {
            <small class="text-danger">Category is required</small>
          }
        </div>

        <!-- Sample Name -->
        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Sample Name</span></div>
          <input type="text" formControlName="name" class="form-control form-control-sm" placeholder="Enter Name">
          @if (sampleForm.get('name')?.invalid && (sampleForm.get('name')?.touched || sampleForm.get('name')?.dirty)) {
            <small class="text-danger">Name is required</small>
          }
        </div>

        <!-- Sample Code / Barcode -->
        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Bar Code</span></div>
          <input type="text" formControlName="sampleCode" class="form-control form-control-sm" placeholder="Bar Code">
          @if (sampleForm.get('sampleCode')?.invalid && sampleForm.get('sampleCode')?.touched) {
            <small class="text-danger">Bar Code is required</small>
          }
        </div>


        <!-- Video Title -->
        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Video Title</span></div>
          <input type="text" formControlName="videoTitle" class="form-control form-control-sm" placeholder="Video Title">
        </div>

        <!-- Video Link -->
        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Youtube Video Link</span></div>
          <input type="text" formControlName="videoLink" class="form-control form-control-sm" placeholder="Youtube Link">
        </div>

        <!-- Sample Image Upload and Preview -->
        <div class="col-12">
          <div class="section-header"><span class="section-title">Sample Images</span></div>
          <input
            type="file"
            id="file"
            class="form-control form-control-sm mt-1"
            multiple
            accept="image/*"
            (change)="getFileDetails($event)">
          <div class="d-flex flex-wrap justify-content-start gap-3 my-2">
            @for (file of sampleFiles; track $index) {
              <div class="card shadow-sm border" style="width: 120px;">
                <div class="position-relative" style="height: 100px;">
                  @if (file.type.startsWith('image')) {
                    <img [src]="file.url" [alt]="file.name" class="card-img-top img-fluid"
                      style="height: 100%; object-fit: contain; border-bottom: 1px solid #dee2e6;">
                  } @else {
                    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px;">
                      <i class="bi bi-file-earmark fs-1 text-muted"></i>
                    </div>
                  }
                </div>
                <div class="card-footer bg-white border-top-0 px-2 py-2 d-flex justify-content-between align-items-center">
                  <small class="text-truncate" style="max-width: 70%;" [title]="file.name">{{ file.name }}</small>
                  <button type="button" class="btn btn-sm btn-outline-danger p-0 px-2" (click)="removeFile($index)"
                    title="Delete" aria-label="Delete">&times;</button>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- TinyMCE Editors -->
        <div class="col-md-6">
          <div class="section-header"><span class="section-title">About Sample</span></div>
          <editor [apiKey]="tinyAPiKey" formControlName="aboutSample" [init]="tinymceConfig" />
        </div>

        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Sample Description</span></div>
          <editor [apiKey]="tinyAPiKey" formControlName="description" [init]="tinymceConfig" />
        </div>

        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Use Instructions</span></div>
          <editor [apiKey]="tinyAPiKey" formControlName="usageInstructions" [init]="tinymceConfig" />
        </div>

        <div class="col-md-6">
          <div class="section-header"><span class="section-title">Sample Ingredients</span></div>
          <editor [apiKey]="tinyAPiKey" formControlName="ingredients" [init]="tinymceConfig" />
        </div>

        <!-- Quantity and Issue Limits -->
        <div class="col-12">
          <div class="section-header d-flex justify-content-between align-items-center">
            <span class="section-title">Issues Limit</span>
          </div>
          <div class="row g-3">
            <div class="col-md">
              <label class="limit-label">Quantity to Add</label>
              <input type="number" formControlName="quantityToBeAdded" class="form-control form-control-sm" min="0" />
            </div>
            <div class="col-md">
              <label class="limit-label">Wholesaler Limit</label>
              <input type="number" formControlName="maxIssueQuantityWholesaler" class="form-control form-control-sm" min="0">
            </div>
            <div class="col-md">
              <label class="limit-label">Retailer Limit</label>
              <input type="number" formControlName="maxIssueQuantityRetailer" class="form-control form-control-sm" min="0">
            </div>
            <div class="col-md">
              <label class="limit-label">Customer Limit</label>
              <input type="number" formControlName="maxIssueQuantityCustomer" class="form-control form-control-sm" min="0">
            </div>
          </div>
        </div>

        <!-- Confirm and Submit Button -->
        <div class="col-12 d-flex justify-content-between align-items-center pt-3">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" formControlName="confirm" />
            <label class="form-check-label small" for="confirmCheckbox">
              I confirm the details are correct
            </label>
          </div>
          <button type="submit" class="btn btn-primary btn-sm px-4 py-1" [disabled]="sampleForm.invalid">
            <i class="fas fa-paper-plane me-2"></i>Submit
          </button>
        </div>

      </div>
    </form>
  </div>
</app-card>
